import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { DepositoDocumentoService } from 'src/app/services/deposito-documento.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { TipoChequeService } from 'src/app/services/tipo-cheque.service';

@Component({
  selector: 'app-modal-deposito-detalle',
  templateUrl: './modal-deposito-detalle.component.html',
  styleUrls: ['../timbrar-deposito.component.scss'],
  providers: [SecurityService]
})
export class ModalDepositoDetalleComponent implements OnInit {

  @ViewChild('verDeposito', { static: true }) modalVerDeposito: ModalDirective;

  // Data &  Tmp
  private rutEmpresa: Number
  private sucursalEmpresa: Number
  loading: boolean
  listaDepositos: any = null
  paginationContext: PaginationContext = new PaginationContext()
  deposito: any

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private depositoDocumentoService: DepositoDocumentoService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private tipoChequeService: TipoChequeService,
  ) {
    this.log = this.clog.log('TIMBRAR-DEPOSITO-EFECTIVO-DETALLE')
  }

  ngOnInit() {
    this.paginationContext.RecordsByPage = 10
  }

  load(deposito) {
    this.deposito = deposito
    this.buscar()
    this.modalVerDeposito.show()
  }

  buscar(pageNumber: number = 1) {
    this.paginationContext.CurrentPage = pageNumber

    this.listaDepositos = null
    this.loading = true

    const { empresa_rut, sucursal_codigo, codigo } = this.deposito
    const inputParams = {
      entidad: {
        empresa_rut,
        sucursal_codigo,
        codigo,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))
    this.depositoDocumentoService.obtenerDepositoTimbrarEspecifico(inputParams, ({ mensajes, respuesta }) => {
      let ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaDepositos = registros
      this.listaDepositos.forEach((deposito, index) => {
        deposito.seleccion = false
        deposito.index = index
        deposito.glosa_estado = this.tipoChequeService.GetLabelByValue(deposito.estado)
        delete deposito.__typename

        deposito.clienteRutFormato = this.rutService.AgregarDV(deposito.cliente_proveedor_rut)
        this.loading = false
      });
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

}
